import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Sin estructura de sesión',
    cost: 'Improvisación que el paciente percibe'
  }, {
    without: 'Sin series por patología',
    cost: 'Cada sesión armada desde cero'
  }, {
    without: 'Sin protocolo de blindaje',
    cost: 'Absorción de la carga energética del paciente'
  }, {
    without: 'Sin planificación anual',
    cost: 'Trabajo reactivo sin visión estratégica'
  }, {
    without: 'Sin guiones de visualización',
    cost: 'Cierres de sesión sin profundidad terapéutica'
  }, {
    without: 'Sin Chi Kung adaptado',
    cost: 'Pacientes con movilidad reducida sin atención'
  }, {
    without: 'Sin protocolo de reseteo',
    cost: 'La carga de la jornada entra a tu casa cada noche'
  }, {
    without: 'Sin sistema sonoro',
    cost: 'Ambiente del consultorio sin intención terapéutica'
  }, {
    without: 'Sin ficha clínica',
    cost: 'Cada consulta sin registro ni continuidad real'
  }, {
    without: 'Sin el sistema',
    cost: 'El mismo ciclo de agotamiento e improvisación'
  }];
  return <Section data-id="element-17">
      <div className="text-center mb-12" data-id="element-18">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[24px] text-brand-purpleDark" data-id="element-19">
          <span className="mr-3" data-id="element-20">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-21">
        <div className="hidden md:block" data-id="element-22">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-23">
            <div className="font-serif font-bold text-lg text-brand-purple" data-id="element-24">
              Sin el Mega Pack
            </div>
            <div className="font-serif font-bold text-lg text-brand-burgundy" data-id="element-25">
              Consecuencia Real
            </div>
          </div>
          <div className="space-y-3" data-id="element-26">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-burgundy/10 bg-white/70" data-id="element-27">
                <div className="text-sm font-medium text-brand-text pr-4" data-id="element-28">
                  {row.without}
                </div>
                <div className="text-sm text-brand-burgundy/90 font-medium" data-id="element-29">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>

        <div className="md:hidden space-y-4" data-id="element-30">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl border-brand-burgundy/10 bg-white/70 space-y-2" data-id="element-31">
              <p className="text-sm font-medium text-brand-text" data-id="element-32">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-brand-burgundy/90 font-medium" data-id="element-33">
                <span className="text-brand-burgundy shrink-0" data-id="element-34">→</span>
                <span className="text-sm" data-id="element-35">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-36">
        <p className="text-xl md:text-2xl font-display italic font-[600] text-brand-purpleDark" data-id="element-37">
          "El terapeuta que tiene un sistema aplica con confianza. El que aplica
          con confianza genera resultados. El que genera resultados crece." 🌿
        </p>
      </div>
    </Section>;
};